<dashboard-dialog-frame class="notes-editor-dialog" [header]="dialogContext.data?.noteId? 'Edit Note':'Create Note'" [actions]="actions" [dialogRef]="dialogRef">
	@if(dialogContext.data; as data){
	<notes-editor-part [noteId]="data.noteId" [personId]="data.personId" [accVentureId]="data.accVentureId"></notes-editor-part>
	}
</dashboard-dialog-frame>